import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import { PageHeader, DataTable, Pill } from "../components/Table";
import { Certificate as CertIcon, QrCode, MagnifyingGlass } from "@phosphor-icons/react";

export default function Certificates() {
  const [certs, setCerts] = useState([]);
  const [sel, setSel] = useState(null);
  const [verifyNo, setVerifyNo] = useState("");
  const [verifyRes, setVerifyRes] = useState(null);

  useEffect(() => { api.get("/certificates").then((r) => setCerts(r.data.certificates)); }, []);

  const verify = async () => {
    try { const r = await api.get(`/certificates/verify/${verifyNo}`); setVerifyRes(r.data); }
    catch (e) { setVerifyRes({ valid: false }); toast.error("Certificate not found"); }
  };

  const columns = [
    { key: "cert_no", header: "Certificate No", render: (r) => <span className="font-mono text-xs">{r.cert_no}</span> },
    { key: "vehicle_number", header: "Vehicle", render: (r) => <span className="font-semibold">{r.vehicle_number}</span> },
    { key: "device_make", header: "Device" },
    { key: "installer", header: "Installer" },
    { key: "status", header: "Status", render: (r) => <Pill color="#34C759">{r.status}</Pill> },
    { key: "valid_until", header: "Valid Until" },
  ];

  return (
    <div className="p-5 space-y-4">
      <PageHeader title="AIS-140 Certificates" subtitle={`${certs.length} installation certificates`}
        actions={<div className="flex gap-2">
          <div className="relative">
            <MagnifyingGlass size={14} className="absolute left-2 top-2.5 text-muted-foreground" />
            <input data-testid="verify-cert-input" value={verifyNo} onChange={(e) => setVerifyNo(e.target.value)} placeholder="Verify cert no"
              className="bg-card border border-border rounded-sm pl-7 pr-3 py-1.5 text-sm w-52" />
          </div>
          <button data-testid="verify-cert-btn" onClick={verify} className="bg-secondary text-white text-sm font-semibold px-3 py-1.5 rounded-sm">Verify</button>
        </div>} />

      {verifyRes && (
        <div className={`border rounded-sm p-3 text-sm ${verifyRes.valid ? "border-[#34C759] bg-[#34C759]/10 text-[#34C759]" : "border-destructive bg-destructive/10 text-destructive"}`}>
          {verifyRes.valid ? `✓ VALID — ${verifyRes.certificate.vehicle_number} · ${verifyRes.certificate.device_make}` : "✗ Certificate invalid or not found"}
        </div>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2"><DataTable testid="certificates-table" columns={columns} rows={certs} onRowClick={setSel} /></div>
        <div className="bg-card border border-border rounded-sm p-5" data-testid="cert-preview">
          {sel ? (
            <div>
              <div className="flex items-center gap-2 mb-4"><CertIcon size={22} weight="fill" className="text-primary" /><span className="font-display font-bold text-lg">AIS-140 Installation Certificate</span></div>
              {[["Certificate", sel.cert_no], ["Vehicle", sel.vehicle_number], ["Chassis", sel.chassis], ["Engine No", sel.engine_no], ["Device", sel.device_make], ["IMEI", sel.imei], ["Installer", sel.installer], ["Valid Until", sel.valid_until]].map(([l, v]) => (
                <div key={l} className="flex justify-between py-1.5 border-b border-border/50 text-sm">
                  <span className="text-muted-foreground">{l}</span><span className="font-semibold font-mono text-xs">{v}</span>
                </div>
              ))}
              <div className="flex justify-center mt-4"><QrCode size={90} weight="thin" /></div>
              <div className="text-center text-xs text-muted-foreground mt-1">Scan to validate</div>
            </div>
          ) : <div className="text-sm text-muted-foreground text-center py-12">Select a certificate to preview</div>}
        </div>
      </div>
    </div>
  );
}
